import React, { FunctionComponent, useEffect, useState } from 'react'
import * as S from './styled'
import { getStorage, ref, getDownloadURL } from 'firebase/storage'
import { useDispatch } from 'react-redux'
import { FETCH_METADATA } from '../../../redux/requests/products/product.actions'
import useConnectRequest from '../../../hooks/useConnectRequest'
import { requestActions } from '../../../redux/requests'

const storage = getStorage()

type OwnProps = { docId: string }

type Props = OwnProps

export const DownloadPDFButton: FunctionComponent<Props> = ({ docId }) => {
  const dispatch = useDispatch()
  const [downloadURL, setDownloadURL] = useState('')

  const { data: metadata } = useConnectRequest(FETCH_METADATA, { multiple: false })

  useEffect(() => {
    dispatch(requestActions.products.fetchMetadata(docId))
  }, [])

  useEffect(() => {
    let mounted = true
    if (metadata) {
      const path = metadata.fileName

      getDownloadURL(ref(storage, path))
        .then(url => {
          if (mounted) {
            setDownloadURL(url)
          }
        })

        .catch(error => {
          console.log({ error })
        })

      return () => {
        mounted = false
      }
    }
  }, [metadata])

  return (
    <S.Button>
      <S.Link href={downloadURL} target="_blank" download="file">
        Öppna
      </S.Link>
    </S.Button>
  )
}

export default DownloadPDFButton
